import Mainpage from "./ui/Mainpage";

export { Mainpage };